import authInstance from "../Interceptor";

export const AddAlcoholEffect = (AlcoholData, config) => {
  return authInstance.post("/type_of_alcohol/add", AlcoholData, config);
};

export const EditAlcoholEffect = (AlcoholId, updatedData) => {
  return authInstance.put(`/type_of_alcohol/update/${AlcoholId}`, updatedData);
};

export const DeleteAlcoholEffect = (AlcoholId) => {
  return authInstance.delete(`/type_of_alcohol/delete/${AlcoholId}`);
};

export const ViewAlcoholEffect = (AlcoholId) => {
  return authInstance.get(`/type_of_alcohol/detail?id=${AlcoholId}`);
};

export const ViewAllAlcoholsEffect = (payload) => {
  return authInstance.get(
    `/type_of_alcohol/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewAlcoholPercentageEffect = () => {
  return authInstance.get(`/cproducts/getsoltalcoholpercentage`);
};

export const ViewWholesalerAlcoholPercentageEffect = () => {
  return authInstance.get(`/cproducts/getsoltalcoholpercentage`);
};

export const ViewAllSearchAlcoholsEffect = () => {
  return authInstance.get(`/type_of_alcohol/list`);
};
